export default "__VITE_ASSET__DblcK89Y__"